// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"c308ba1d","132":"73b573e0","479":"72fba928"}[chunkId] + ".css";
};